(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-perk-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-mobile-perk-bar]');
    if (!bar) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const storageKey = 'ceyrah-mobile-perk-bar-dismissed';
    const dismissButton = bar.querySelector('[data-mobile-perk-dismiss]');
    const hero = document.querySelector('#MainContent > .shopify-section');
    const footer = document.querySelector('footer');
    let showTimer;
    let heroObserver;
    let footerObserver;
    let heroScrollHandler;
    let footerVisible = false;
    let hasShown = false;

    const isDismissed = () => {
      try {
        return window.sessionStorage.getItem(storageKey) === 'true';
      } catch {
        return false;
      }
    };

    const setVisible = (visible) => {
      bar.dataset.visible = visible ? 'true' : 'false';
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      scheduleStickyOffset();
    };

    const clearHeroTrigger = () => {
      if (showTimer) window.clearTimeout(showTimer);
      heroObserver?.disconnect();
      if (heroScrollHandler) window.removeEventListener('scroll', heroScrollHandler);
    };

    const show = () => {
      if (!mobileQuery.matches || isDismissed() || footerVisible) return;
      hasShown = true;
      clearHeroTrigger();
      setVisible(true);
    };

    const showAfterHero = () => {
      if (!hero || hero.getBoundingClientRect().bottom > 0) return;
      show();
    };

    const setStickyOffset = (value) => {
      if (value === null) {
        if (bar.style.getPropertyValue('--mobile-perk-bottom-offset')) {
          bar.style.removeProperty('--mobile-perk-bottom-offset');
        }
        return;
      }

      if (bar.style.getPropertyValue('--mobile-perk-bottom-offset') !== value) {
        bar.style.setProperty('--mobile-perk-bottom-offset', value);
      }
    };

    const updateStickyOffset = () => {
      // Only the visible bar needs to clear the sticky add to cart bar, so skip all measurement while it is hidden.
      if (!mobileQuery.matches || bar.dataset.visible !== 'true') {
        setStickyOffset(null);
        return;
      }

      const stickyBar = document.querySelector("sticky-add-to-cart .sticky-add-to-cart__bar[data-stuck='true']");
      if (!stickyBar) {
        setStickyOffset(null);
        return;
      }

      const stickyRect = stickyBar.getBoundingClientRect();
      if (stickyRect.top >= window.innerHeight || stickyRect.bottom <= 0) {
        setStickyOffset(null);
        return;
      }

      setStickyOffset(`${Math.ceil(window.innerHeight - stickyRect.top + 8)}px`);
    };

    // Scroll and resize fire many times per frame. Coalesce the sticky offset measurement into one read per frame.
    let stickyOffsetFrame = 0;
    const scheduleStickyOffset = () => {
      if (stickyOffsetFrame) return;
      stickyOffsetFrame = window.requestAnimationFrame(() => {
        stickyOffsetFrame = 0;
        updateStickyOffset();
      });
    };

    const dismiss = () => {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch {}
      clearHeroTrigger();
      setVisible(false);
    };

    if (!mobileQuery.matches || isDismissed()) return;

    dismissButton?.addEventListener('click', dismiss);
    showTimer = window.setTimeout(show, 5000);

    if (hero && 'IntersectionObserver' in window) {
      heroObserver = new IntersectionObserver((entries) => {
        const [entry] = entries;
        if (entry && !entry.isIntersecting && entry.boundingClientRect.bottom <= 0) show();
      });
      heroObserver.observe(hero);
    } else if (hero) {
      heroScrollHandler = showAfterHero;
      window.addEventListener('scroll', heroScrollHandler, { passive: true });
    }

    if (footer && 'IntersectionObserver' in window) {
      footerObserver = new IntersectionObserver((entries) => {
        const [entry] = entries;
        footerVisible = Boolean(entry?.isIntersecting);
        if (footerVisible) {
          setVisible(false);
        } else if (hasShown && !isDismissed()) {
          setVisible(true);
        }
      });
      footerObserver.observe(footer);
    }

    scheduleStickyOffset();
    window.addEventListener('resize', scheduleStickyOffset, { passive: true });
    window.addEventListener('scroll', scheduleStickyOffset, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
